import __request__ from "routing/request";
export function list(nodeId, requestOptions) {
  return __request__("GET", `/cluster/${nodeId}/plugins`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
